import * as React from 'react'
import { useTheme } from '@mui/material'

const CircleCrossIcon = (props) => {
  const theme = useTheme()

  return (
    <svg width={118} height={118} viewBox="0 0 118 118" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M76.1429 41.8571L41.8572 76.1428M41.8572 41.8571L76.1429 76.1428M116.143 59C116.143 90.5591 90.5592 116.143 59 116.143C27.4409 116.143 1.85718 90.5591 1.85718 59C1.85718 27.4408 27.4409 1.85712 59 1.85712C90.5592 1.85712 116.143 27.4408 116.143 59Z"
        stroke={props.color ? props.color : theme.palette.icon.error.color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default CircleCrossIcon
